import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=27ae9465"
import script from "./AddressDetails.vue?vue&type=script&lang=ts"
export * from "./AddressDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports